import { formatDistanceToNow } from 'date-fns'
import React from 'react'
import { GeckoKestrelModel } from 'types'

import { ResultCardProps } from './DefaultResultCard'
import {
  MetaItem,
  ResultDescription,
  ResultHeader,
  ResultItemContainer,
  ResultMeta,
  ResultTitle,
  ResultType,
} from './ResultCardStyles'

export const KestrelModelResultCard: React.FC<ResultCardProps> = ({
  entry,
  onClick,
}) => {
  const kestrelModel = entry as GeckoKestrelModel

  const handleClick = () => {
    onClick?.(entry)
  }

  const timeAgo = formatDistanceToNow(new Date(kestrelModel.updated_at), {
    addSuffix: true,
  })

  return (
    <ResultItemContainer onClick={handleClick}>
      <ResultHeader>
        <ResultTitle>
          {kestrelModel.data.displayName ??
            `${kestrelModel.id} - ${kestrelModel.data.inspection_type}`}
        </ResultTitle>
        <ResultType>Kestrel Model</ResultType>
      </ResultHeader>
      <ResultMeta>
        <MetaItem>Updated {timeAgo}</MetaItem>
      </ResultMeta>
      {kestrelModel.data.underlyingAsset && (
        <ResultDescription>
          {kestrelModel.data.underlyingAsset}
        </ResultDescription>
      )}
    </ResultItemContainer>
  )
}
